import { KeywordSuggest } from 'components/KeywordSuggest';
import { ConditionsAreaWrapper } from 'components/SearchSideBar/ConditionsAreaWrapper';
import { SidebarSection } from 'components/SearchSideBar/SidebarSection';
import { FC, MouseEvent, memo } from 'react';
import { SuggestItems } from '@doda/common/src/interfaces/suggestDispatcher';
import { JobCountQuery } from '@doda/common/src/services/getJobCountAPI';
import { IncludedKeywordCategoryRequestCode } from '@doda/api-client/aspida/@types';
import styles from './index.module.scss';

/**
 * SearchKeyword
 * @param state 状態をまとめたオブジェクト
 * @param updateFunctions 更新処理をまとめたオブジェクト
 */
interface SearchKeyword {
  state: {
    searchText: string;
    suggests: SuggestItems['items'];
    searchCategory: IncludedKeywordCategoryRequestCode | undefined;
  };
  updateFunctions: {
    onChangeText: (event: string) => void;
    onClickSuggest: (event: MouseEvent<HTMLButtonElement>) => void;
    onChangeUpdateKeyword: (value: IncludedKeywordCategoryRequestCode) => void;
    onFocusInput: () => void;
    resetSuggests: () => void;
  };
}

/**
 * Props
 * @param include 含む用のオブジェクト
 * @param exclude 含まない用のオブジェクト
 * @param updateJobCount 求人件数更新処理
 * @param onChangeIsShowOverlay オーバーレイ表示処理
 */
interface Props {
  include: SearchKeyword;
  exclude: SearchKeyword;
  updateJobCount: (currentCondition?: JobCountQuery) => Promise<void>;
  onChangeIsShowOverlay: () => void;
}

export const SearchKeyword: FC<Props> = memo(
  ({ include, exclude, updateJobCount, onChangeIsShowOverlay }) => {
    return (
      <SidebarSection title="キーワード">
        <ConditionsAreaWrapper>
          <div className={styles['search-keyword__wrapper']}>
            <KeywordSuggest
              state={{
                isInclude: true,
                ...include.state,
              }}
              functions={include.updateFunctions}
              updateJobCount={updateJobCount}
              onChangeIsShowOverlay={onChangeIsShowOverlay}
            />
            <KeywordSuggest
              state={{
                isInclude: false,
                ...exclude.state,
              }}
              functions={exclude.updateFunctions}
              updateJobCount={updateJobCount}
              onChangeIsShowOverlay={onChangeIsShowOverlay}
            />
          </div>
        </ConditionsAreaWrapper>
      </SidebarSection>
    );
  }
);

SearchKeyword.displayName = 'SearchKeyword';
